// (function () {
//   // 1. 强力防调试（build后不删除）
//   setInterval(function() {
//     try {
//       (function(){}).constructor("debugger")()
//     }catch(e){}
//   },50)
// })()
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css' // Element 默认样式
import '@/assets/css/theme.css' // 自定义明暗模式样式
import App from './App.vue'
import router from './router'
import './plugins/element.js'
import VueAnimateNumber from 'vue-animate-number'
import 'animate.css'
import 'default-passive-events'
import store from './store'
import apiFun from './request/api'
import preventReClick from './assets/js/preventRepeatClick'
import { WOW } from 'wowjs'

Vue.use(ElementUI)

Vue.use(preventReClick)
Vue.prototype.$apiFun = apiFun
Vue.use(VueAnimateNumber)
Vue.prototype.$bus = new Vue()

Vue.prototype.$wow = new WOW({
  live: false
})

Vue.config.productionTip = false

// 修复 storage 事件触发（标准写法，无废弃API）
Vue.prototype.setSessionItem = function (key, newVal) {
  sessionStorage.setItem(key, newVal)
  const event = new StorageEvent('storage', {
    key,
    newValue: newVal,
    storageArea: sessionStorage
  })
  window.dispatchEvent(event)
}

// 路由守卫（修复逻辑 + 修复死循环 + 修复外部跳转）
router.beforeEach((to, from, next) => {
  const host = window.location.hostname

  // 域名跳转（只执行一次，防止循环）
  if (host.includes('www.7daili.com') && to.path !== '/') {
    window.location.replace('https://7daili.com')
    return
  }

  const token = sessionStorage.getItem('token')

  // 需要登录的页面
  if (to.meta?.requireAuth) {
    if (token) {
      next()
    } else {
      Vue.prototype.$message.warning('请先登录！')
      next('/')
    }
  } else {
    next()
  }
})

// 挂载 Vue
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
